import { useEffect, useState } from "react";
import { db } from "@firebase-local/firebase";

type DatabaseState = "connecting" | "connected" | "disconnected";

export default function useDatabaseState() {
    const [state, setState] = useState<DatabaseState>("connecting");

    useEffect(() => {
        // https://firebase.google.com/docs/database/web/offline-capabilities#section-connection-state
        const infoConnectedRef = db.ref(".info/connected");
        infoConnectedRef.on("value", (snapshot) => {
            const infoConnected: boolean = snapshot.val();
            setState((originalState) => {
                if (originalState === "connecting") {
                    if (infoConnected) {
                        return "connected";
                    } else {
                        return "connecting";
                    }
                } else {
                    if (infoConnected) {
                        return "connected";
                    } else {
                        return "disconnected";
                    }
                }
            });
        });

        return () => infoConnectedRef.off("value");
    }, []);

    return state;
}
